export default __webpack_public_path__ + "static/OneOwner-add1680c67f386e8345604463f2f3074.svg";